import React, { useMemo } from "react";

import { isNotUndefined } from "@/shared/FunctionCore";
import "@/components/DrsAndAAASeal/DrsSeal.scss"
import { sealImages } from "@/components/DrsAndAAASeal/resources/images";

interface DrsSealProps {
	"isHu": boolean;
	"meritColor": string;
	"meritScore": string;
	"drsContentLocalized": string
}

const DrsAndAAASeal = ({
	isHu,
	meritColor,
	meritScore,
	drsContentLocalized
}: DrsSealProps): JSX.Element => {

	const meritSealRankImg = useMemo(() => {
		// Default or global one
		let sealImgName = "dunsRegisteredSeal";

		if (isHu && isNotUndefined(meritScore)) {
			sealImgName = `${meritColor}${meritScore}`;
		}

		return sealImages[sealImgName as keyof typeof sealImages];
	}, [isHu, meritColor, meritScore]);

	// This component is used for DRS and AAA rating(hu)
	if (!(isNotUndefined(meritSealRankImg))) {
		return <></>;
	}
	
	return (
		<div className="drsSection">
			<div
				className="drsImage"
				style={{ "backgroundImage": `url(${meritSealRankImg})`, "backgroundRepeat": "no-repeat" }}
			/>

			<div className="drsText">
				{drsContentLocalized ??
					"A D-U-N-S® Registered Seal indicates that a company has been assigned a Dun & Bradstreet D-U-N-S® Number"
				}
			</div>
		</div>
	);
};

export default DrsAndAAASeal;
